<template>
    <div class="container py-5">
        <h5> <strong> Syarat &amp; Ketentuan OPM 2018 #1 </strong> </h5>
        <ul>
            <li style="display:flex;">
                <i
                    style="display:inline-block; width:15px; margin-right:20px; text-transform:none; font-weight: bold; text-align: right;">
                    1. </i>
                <p style="display:inline-block;">
                    Masa Pendaftaran 14 November – 27 November 2018 pukul 18.00 WIB.
                </p>
            </li>
            <li style="display:flex;">
                <i
                    style="display:inline-block; width:15px; margin-right:20px; text-transform:none; font-weight: bold; text-align: right;">
                    2. </i>
                <p style="display:inline-block;">
                    Cara Pendaftaran, dengan sistem Online melalui website: https://opm.apjii.or.id
                </p>
            </li>
            <li style="display:flex;">
                <i
                    style="display:inline-block; width:15px; margin-right:20px; text-transform:none; font-weight: bold; text-align: right;">
                    3. </i>
                <p style="display:inline-block;">
                    Anggota (Perusahaan) telah menyelesaikan seluruh tagihan APJII yang jatuh tempo pada tanggal 31
                    Agustus 2018 pada saat melakukan pendaftaran.
                </p>
            </li>
            <li style="display:flex;">
                <i
                    style="display:inline-block; width:15px; margin-right:20px; text-transform:none; font-weight: bold; text-align: right;">
                    4. </i>
                <p style="display:inline-block;">
                    Setiap perusahaan dapat mendaftarkan paling banyak 2 (dua) peserta.
                </p>
            </li>
            <li style="display:flex;">
                <i
                    style="display:inline-block; width:15px; margin-right:20px; text-transform:none; font-weight: bold; text-align: right;">
                    5. </i>
                <p style="display:inline-block;">
                    Apabila yang menjadi Peserta adalah Direktur Utama/Direktur, harus menyertakan Surat Pernyataan
                    (discan dan diupload).
                </p>
            </li>
            <li style="display:flex;">
                <i
                    style="display:inline-block; width:15px; margin-right:20px; text-transform:none; font-weight: bold; text-align: right;">
                    6. </i>
                <p style="display:inline-block;">
                    Apabila yang menjadi Peserta selain Direktur Utama/Direktur, harus menyertakan Surat Kuasa dari
                    Direktur Utama/Direktur (discan dan diupload).
                </p>
            </li>
            <li style="display:flex;">
                <i
                    style="display:inline-block; width:15px; margin-right:20px; text-transform:none; font-weight: bold; text-align: right;">
                    7. </i>
                <p style="display:inline-block;">
                    Peserta harus menyertakan foto wajah terbaru (diupload).
                </p>
            </li>
            <li style="display:flex;">
                <i
                    style="display:inline-block; width:15px; margin-right:20px; text-transform:none; font-weight: bold; text-align: right;">
                    8. </i>
                <p style="display:inline-block;">
                    KTP/SIM/PASPOR yang masih berlaku (discan dan diupload).
                </p>
            </li>
            <li style="display:flex;">
                <i
                    style="display:inline-block; width:15px; margin-right:20px; text-transform:none; font-weight: bold; text-align: right;">
                    9. </i>
                <p style="display:inline-block;">
                    Seluruh Surat Asli harus dibawa pada saat APJII Open Policy Meeting (OPM) 2018.
                </p>
            </li>
            <li style="display:flex;">
                <i
                    style="display:inline-block; width:15px; margin-right:20px; text-transform:none; font-weight: bold; text-align: right;">
                    10. </i>
                <p style="display:inline-block;">
                    Peserta bersedia mematuhi seluruh syarat dan ketentuan yang telah ditetapkan Panitia APJII Open
                    Policy Meeting (OPM) 2018, baik syarat dan ketentuan Peserta, maupun syarat dan ketentuan selama
                    mengikuti APJII Open Policy Meeting (OPM) 2018.
                </p>
            </li>
            <li style="display:flex;">
                <i
                    style="display:inline-block; width:15px; margin-right:20px; text-transform:none; font-weight: bold; text-align: right;">
                    11. </i>
                <p style="display:inline-block;">
                    Peserta masih dapat diubah (diedit) sebelum Masa Pendaftaran ditutup.
                </p>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    

}
</script>